// Third party imports
import React from "react";
import classnames from "classnames";
import Tooltip from "ui/modules/Tooltip";

// Styles and icons
import useStyles from "../../Subscriptions/components/TableFields/TableFields.styles";
import { DISPUTE_STATUS } from "../constants/disputes.constant";

export const StatusField = ({ record = {}, source }) => {
  const classes = useStyles();
  const { title, variant, icon } = DISPUTE_STATUS[record[source]] ?? {};
  const statusChip = (
    <span
      className={classnames(
        classes.status,
        variant && classes[`status__${variant}`],
        "!tw-w-max"
      )}
    >
      {icon}
      {title}
    </span>
  );
  return statusChip;
};

export const TooltipHeaderField = ({ label, note, className = "" }) => (
  <div className={`tw-flex tw-items-center ${className}`}>
    <span> {label} </span>
    {note && (
      <Tooltip text={note} className="tw-flex tw-items-start !tw-ml-[5px]" />
    )}
  </div>
);
